"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;
var _default = [{
  code: '1353951',
  name: 'Holiday',
  mobileName: 'Holiday',
  url: '/holiday',
  newCategoryTagEnabled: false,
  hidden: false,
  disabledOnMobile: false,
  rank: 9999,
  enableDate: 1531810800000,
  disableDate: 0,
  linkedCategory: null,
  dynamicContentIds: {
    '0': ['holiday_tp_subnav_dropdown_1x1', 'holiday_tp_subnav_dropdown_1x4']
  },
  subCategories: null
}, {
  code: '1353952',
  name: 'Birth Announcements',
  mobileName: 'Birth Announcements',
  url: '/birth-announcements',
  newCategoryTagEnabled: false,
  hidden: false,
  disabledOnMobile: false,
  rank: 9999,
  enableDate: 1531810800000,
  disableDate: 0,
  linkedCategory: null,
  dynamicContentIds: {
    '0': ['birthannouncements_tp_subnav_dropdown_1x1', 'birthannouncements_tp_subnav_dropdown_1x4']
  },
  subCategories: null
}, {
  code: '1353953',
  name: 'Invitations',
  mobileName: 'Invitations',
  url: '/invitations',
  newCategoryTagEnabled: false,
  hidden: false,
  disabledOnMobile: false,
  rank: 9999,
  enableDate: 1531810800000,
  disableDate: 0,
  linkedCategory: null,
  dynamicContentIds: {
    '0': ['invitations_tp_subnav_dropdown_1x1', 'invitations_tp_subnav_dropdown_1x4']
  },
  subCategories: null
}, {
  code: '1353954',
  name: 'Stationery',
  mobileName: 'Stationery',
  url: '/stationery',
  newCategoryTagEnabled: false,
  hidden: false,
  disabledOnMobile: false,
  rank: 9999,
  enableDate: 1531810800000,
  disableDate: 0,
  linkedCategory: null,
  dynamicContentIds: {
    '0': ['stationery_tp_subnav_dropdown_1x1', 'stationery_tp_subnav_dropdown_1x4']
  },
  subCategories: null
}, {
  code: '999',
  name: 'Inspiration',
  mobileName: 'Inspiration',
  url: '/inspiration',
  newCategoryTagEnabled: false,
  hidden: false,
  disabledOnMobile: false,
  rank: 0,
  enableDate: 0,
  disableDate: 0,
  linkedCategory: null,
  dynamicContentIds: {
    '0': ['inspiration_tp_subnav_dropdown_1x1', 'inspiration_tp_subnav_dropdown_1x4']
  },
  subCategories: null
}, {
  code: '1263147',
  name: 'Special Offers',
  mobileName: 'Special Offers',
  url: '/coupon-codes-promotions',
  newCategoryTagEnabled: false,
  hidden: false,
  disabledOnMobile: false,
  rank: 9999,
  enableDate: 1493794800000,
  disableDate: 0,
  linkedCategory: null,
  dynamicContentIds: null,
  subCategories: null
}];
exports.default = _default;